import { EsignatureType } from '~/enums/EsignatureType';

import {
  ESigIntegrationsResponse,
  ESignatureIntegration,
  EsignatureIntegrationType,
  ESigVendorsResponse,
} from '../../types';

export const normalizeESignatureIntegrations = (
  vendors: ESigVendorsResponse | undefined = [],
  integrations: ESigIntegrationsResponse | undefined = [],
): ESignatureIntegration[] => {
  const safeVendors = Array.isArray(vendors) ? vendors : [];
  const safeIntegrations = Array.isArray(integrations) ? integrations : [];

  const integrationMap = new Map(
    safeIntegrations.map((i) => [i.attributes.vendor, i]),
  );
  return safeVendors.map((p) => {
    const integration = integrationMap.get(p.id);

    return {
      id: integration?.id ?? `mock-${p.id}`,
      providerName: p.attributes.name.toLowerCase() as EsignatureType,
      integrationType: (integration?.attributes.type?.toLowerCase() ??
        'company') as EsignatureIntegrationType,
      authenticatedUserCount:
        integration?.attributes.authenticated_user_count ?? 0,
      isActive: integration?.attributes.has_active_token ?? false,
      isCompanyAccountLoggedIn:
        integration?.attributes.type?.toLowerCase() === 'company',
    };
  });
};
